import { WelcomeTour, WelcomeTourTrigger } from './modules/WelcomeTour';
import FeaturesChecklist from './modules/FeaturesChecklist';

export default {
  WelcomeTour,
  WelcomeTourTrigger,
  FeaturesChecklist
};
